import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';
import smoothscroll from 'smoothscroll-polyfill';

class Scroll extends Component<any> {
  private get targetScrollElement() {
    return this.locationHash && document.querySelector(this.locationHash);
  }

  private get location() {
    return get(this.props, 'location');
  }

  private get locationHash() {
    return get(this.props, 'location.hash');
  }

  private get pathname() {
    return get(this.props, 'location.pathname');
  }

  public componentDidUpdate(prevProps: any) {
    this.resetScroll(prevProps);
    this.scrollElementToView();
  }

  public componentDidMount() {
    smoothscroll.polyfill();
    window.addEventListener('scroll', this.changeHeaderColour());
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.changeHeaderColour());
  }

  public render() {
    return <div>{this.props.children}</div>;
  }

  public scrollElementToView(config: object = { behavior: 'instant', block: 'start', inline: 'start' }) {
    if (!!this.targetScrollElement) {
      this.removeUrlHash();
      this.scrollToElement(config);
    }
  }

  public scrollToElement(config: object) {
    this.targetScrollElement.scrollIntoView(config);
  }

  private resetScroll(prevProps: any) {
    if (this.location !== prevProps.location && !this.locationHash) {
      window.scroll({ top: 0, left: 0, behavior: 'instant' });
    }
  }

  private removeUrlHash() {
    if ('pushState' in history) {
      history.pushState('', document.title, this.pathname);
    }
  }

  changeHeaderColour = (
    yPosition: number = window.pageYOffset,
    header: any = document.querySelector('.main-header')
  ) => (
    ev: Event
  ) => {
    if (!!header) {
      (yPosition >= 100)
        ? header.classList.add('main-header-dark')
        : header.classList.remove('main-header-dark');
    }
  }
}

export default withRouter(Scroll);



// WEBPACK FOOTER //
// ./src/containers/Scroll/index.tsx